import { ToggleButton, ToggleButtonGroup } from "@mui/material";

import type { FunnelPeriod } from "../../../types/dealFunnel";

const PERIOD_OPTIONS: { value: FunnelPeriod; label: string }[] = [
  { value: "month", label: "Month" },
  { value: "quarter", label: "Quarter" },
  { value: "year", label: "Year" },
];

export function PeriodToggle(props: {
  value: FunnelPeriod;
  onChange: (period: FunnelPeriod) => void;
}) {
  const { value, onChange } = props;

  return (
    <ToggleButtonGroup
      exclusive
      size="small"
      value={value}
      onChange={(_, next: FunnelPeriod | null) => {
        if (next) onChange(next);
      }}
      aria-label="Time period"
    >
      {PERIOD_OPTIONS.map((o) => (
        <ToggleButton key={o.value} value={o.value}>
          {o.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}
